import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Toggle from 'react-toggle';
import styles from '../../components/Settings/SettingsMenu/styles.module.css';
import componentStyles from './blockedProfileTypes.module.css';

const Component = ({
  formField,
  fieldHelpers,
  readOnly,
  values: profileTypes,
}) => {
  const { t } = useTranslation();
  
  const blockedSet = new Set(formField.value || []);
  
  const handleToggle = (profileTypeKey, isBlocked) => {
    const currentBlocked = formField.value || [];
    let updatedBlocked;
    
    if (isBlocked) {
      updatedBlocked = [...currentBlocked, profileTypeKey];
    } else {
      updatedBlocked = currentBlocked.filter(key => key !== profileTypeKey);
    }
    
    fieldHelpers.setTouched(true, false);
    fieldHelpers.setValue(updatedBlocked);
  };

  return (
    <div>
      <table className={componentStyles.table} style={{ width: '97%' }}>
        <thead>
          <tr>
            <th>
                <div className={cn('text-uppercase', 'font-weight-bold', styles.categoryText, 'mt-3')}>
                  {t('Restrict Profile Type')}
                </div>
                <div className={cn('font-weight-bold', styles.categoryText, 'mt-3')}>
                  {t('Turn the toggle ON next to a profile type below to restrict access to that profile type for this user.')}
                </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {profileTypes && profileTypes.length === 0 && (
            <tr>
              <td colSpan={2}>
                {t('No profile types available.')}
              </td>
            </tr>
          )}
          {profileTypes?.map((profileType) => {
            const profileTypeKey = profileType.id || profileType.key;
            const profileTypeLabel = profileType.value || profileType.label || profileTypeKey;
            const isBlocked = blockedSet.has(profileTypeKey);
            
            return (
              <tr key={profileTypeKey}>
                <td>{t(profileTypeLabel)}</td>
                <td style={{ textAlign: 'end' }}>
                  <Toggle
                    disabled={readOnly}
                    checked={isBlocked}
                    icons={false}
                    onChange={(event) => {
                      handleToggle(profileTypeKey, event.target.checked);
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default {
  name: 'Blocked Profile Types',
  options: [],
  Component,
};

